// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"45ae861b","453":"ef9d1050","643":"e1c5e453","903":"3119fc3e"}[chunkId] + ".chunk.js";
};